module.exports = __webpack_public_path__ + "static/media/CiscoSansTTThin.85609a8e.ttf";